import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';

function getOrganizationTheme() {
  return httpService.get(ApiUrl.ORGANIZATIONTHEME + '?organization_id=' + Storages.MainStorage.getItem(StorageKeys.Keys.LICENSEAPIKEY).organization_id);
}

const obj = { getOrganizationTheme };

export default obj;
